webpackJsonp([1],{

/***/ 147:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(57);
	
	var _get = __webpack_require__(67);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _gatsbyHelpers = __webpack_require__(13);
	
	var _typography = __webpack_require__(10);
	
	var _Separator = __webpack_require__(146);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _InquiryForm = __webpack_require__(145);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	var _BlogThumbnailContainer = __webpack_require__(142);
	
	var _BlogThumbnailContainer2 = _interopRequireDefault(_BlogThumbnailContainer);
	
	var _Header = __webpack_require__(83);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactHelmet = __webpack_require__(129);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, (BlogIndex.__proto__ || Object.getPrototypeOf(BlogIndex)).apply(this, arguments));
	  }
	
	  _createClass(BlogIndex, [{
	    key: 'render',
	    value: function render() {
	      var metadata = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	      var blogEntries = (0, _get2.default)(this, 'props.data.allMarkdown.edges');
	      return Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(_reactHelmet2.default, {
	          title: 'Blog | ' + metadata.title,
	          meta: [{ name: 'og:type', content: 'article' }, { name: 'og:image', content: metadata.photoURL || '' }, { name: 'og:url', content: 'krasadev.com' }, { name: 'og:description', content: metadata.description }, { name: 'fb:app_id', content: metadata.fbAppID }]
	        }),
	        Glamor.createElement(_Header2.default, null),
	        Glamor.createElement(_Separator2.default, { text: 'Blog', angle: false }),
	        Glamor.createElement(_BlogThumbnailContainer2.default, { blogEntries: blogEntries }),
	        Glamor.createElement(_InquiryForm2.default, null)
	      );
	    }
	  }]);
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	BlogIndex.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '\n{\n  site {\n    buildTime\n    siteMetadata {\n      title\n      homeCity\n      author\n      description\n      fbAppID\n    }\n  }\n  allMarkdown(first: 2000) {\n    edges {\n      node {\n        path\n        frontmatter {\n          title\n          photoURL\n          previewText\n        }\n      }\n    }\n  }\n}\n';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }

});


// WEBPACK FOOTER //
// page-component---pages-blog-index-js-adefe9154b35007c3909.js